import { render, staticRenderFns } from "./addPermissions.vue?vue&type=template&id=297fc9ea&"
import script from "./addPermissions.vue?vue&type=script&lang=js&"
export * from "./addPermissions.vue?vue&type=script&lang=js&"
import style0 from "./addPermissions.vue?vue&type=style&index=0&id=297fc9ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports